import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
    setAddress,
    setCap,
    setCity,
    setCompany,
    setCountry,
    setFirstName,
    setLanguage,
    setLastName,
    setOrderNote,
    setOrderRef,
    setOrderType,
    setUsername,
    setVat
} from '../../store/actions/orderActions';
import AIDAForm from './AIDAForm/AIDAForm';
import Summary from './Summary/Summary';

const isRunningLocally = () => {
    return process.env.NODE_ENV === 'development' && [ 'localhost', '127.0.0.1' ].includes(window.location.hostname);
};

export default function OrderForm() {
    const dispatch = useDispatch();
    const [ isSubmitting, setSubmitting ] = useState(false);

    useEffect(() => {
        if (!isRunningLocally()) {
            return;
        }

        dispatch(setFirstName('firstName'));
        dispatch(setLastName('lastName'));
        dispatch(setCompany('company'));
        dispatch(setVat('vat'));
        dispatch(setAddress('address'));
        dispatch(setCity('city'));
        dispatch(setCap('cap'));
        dispatch(setUsername('username@example.com'));
        dispatch(setCountry('IT'));
        dispatch(setLanguage('IT'));
        dispatch(setOrderRef('orderRef'));
        dispatch(setOrderNote('orderNote'));
        dispatch(setOrderType('new'));
    }, [ dispatch ]);

    return (
        <div className="container">
            <h1>AIDA order form</h1>
            <div className="columns">
                <div className="column is-8">
                    <div className="box">
                        <AIDAForm isSubmitting={isSubmitting} />
                    </div>
                </div>
                <div className="column is-4">
                    <Summary isSubmitting={isSubmitting} setSubmitting={setSubmitting} />
                </div>
            </div>
        </div>
    );
}
